import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

class UserId extends React.PureComponent {
    render() {
        return (
            <a href={`/user/${this.props.uuid}`}>{this.props.name || this.props.uuid}</a>
        );
    }
}

UserId.propTypes = {
    uuid: PropTypes.string,
    name: PropTypes.string,
};

function BanView(props) {
    function ban(value) {
        fetch('/api/data/comment/hide', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: props.id,
                hide: value,
            }),
        }).then(() => {
            props.onUpdate();
        });
    }
    if (props.banned) {
        return (<div>
            true&nbsp;
            <Button onClick={() => ban(false)}>Unban</Button>
        </div>);
    }
    return (<div>
        false&nbsp;
        <Button onClick={() => ban(true)}>Ban</Button>
    </div>);
}

BanView.propTypes = {
    id: PropTypes.string.isRequired,
    banned: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
};

class CommentThread extends React.PureComponent {
    state = {
        comments: null,
    };

    onRefresh = () => {
        this.fetchCommentList();
    }

    MapCommentColumns = [
        {
            Header: "Hide",
            accessor: 'hide',
            Cell: props => <BanView id={props.original._id} banned={!!props.original.hide} onUpdate={this.onRefresh} />,
            width: 100,
        },
        {
            Header: "User",
            accessor: 'user_id',
            Cell: props => <UserId uuid={props.original.user_id} name={props.original.name} />,
            width: 300,
        },
        {
            Header: "Content",
            accessor: "content",
            Cell: props => <div style={{ whiteSpace: 'normal' }}>{props.value}</div>,
        },
        {
            Header: "Time",
            accessor: 'time',
            Cell: props => new Date(props.value).toLocaleString(),
            width: 200,
        },
        {
            Header: "Likes",
            accessor: 'likes',
            width: 150,
        },
    ];

    componentDidMount() {
        this.fetchCommentList();
    }

    async fetchCommentList() {
        const response = await fetch('/api/data/search/map_comment', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: {
                    map_key: this.props.thread._id,
                },
                sort: {
                    likes: -1,
                    time: -1,
                },
                limit: 100,
            }),
        });
        const result = await response.json();
        this.setState({ comments: result.results });
    }

    render() {
        if (!this.state.comments) {
            return "Loading...";
        }
        return (
            <ReactTable
                columns={this.MapCommentColumns}
                pageSize={this.state.comments.length}
                showPagination={false}
                data={this.state.comments}
            />
        );
    }
}

CommentThread.propTypes = {
    thread: PropTypes.any,
};

class CommentStats extends React.PureComponent {
    state = {
        results: null,
    };

    componentDidMount() {
        this.fetchCommentStats();
    }

    async fetchCommentStats() {
        const response = await fetch('/api/data/aggregate/map_comment', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline: [
                    {
                        $group: {
                            _id: "$map_key",
                            count: { $sum: 1 },
                            total_likes: { $sum: "$likes" },
                        }
                    },
                    {
                        $group: {
                            _id: null,
                            thread_count: { $sum: 1 },
                            count: { $sum: "$count" },
                            total_likes: { $sum: "$total_likes" },
                        }
                    }
                ],
            }),
        });
        const result = await response.json();
        this.setState({ results: result.results });
    }

    render() {
        if (!this.state.results) {
            return "Loading...";
        }
        const record = this.state.results.length > 0 ? this.state.results[0] : { thread_count: 0, count: 0, total_likes: 0 };
        return (
            <h2>Total # of threads: {record.thread_count}, comments: {record.count}, likes: {record.total_likes}</h2>
        );
    }
}

export class Comments extends React.PureComponent {
    THREAD_COLUMNS = [
        {
            Header: "#",
            accessor: 'index',
            Cell: row => <div>{row.index}</div>,
            width: 50,
        },
        {
            Header: 'Map Key',
            accessor: '_id',
            width: 150,
        },
        {
            Header: 'Comment Count',
            accessor: 'count',
            width: 150,
        },
        {
            Header: 'Comment Likes',
            accessor: 'total_likes',
            width: 150,
        },
        {
            Header: 'Updated',
            accessor: 'latest_comment',
            Cell: props => new Date(props.value).toLocaleString(),
        }
    ];

    createThreadComponent = row => {
        return (
            <CommentThread thread={row.original} />
        );
    }

    state = {
        threads: null,
    };

    componentDidMount() {
        this.fetchGuildList();
    }

    async fetchGuildList() {
        const response = await fetch('/api/data/aggregate_all/map_comment', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline: [
                    {
                        $group: {
                            _id: "$map_key",
                            count: { $sum: 1 },
                            total_likes: { $sum: "$likes" },
                            latest_comment: { $max: "$time" },
                        }
                    },
                    {
                        $sort: { count: -1, total_likes: -1 },
                    }
                ],
            }),
        });
        const result = await response.json();
        this.setState({ threads: result.results });
    }

    render() {
        if (!this.state.threads) {
            return "Loading...";
        }
        window.threads = this.state.threads;
        return (
            <div>
                <CommentStats />
                <ReactTable
                    data={this.state.threads}
                    columns={this.THREAD_COLUMNS}
                    pageSize={Math.min(this.state.threads.length, 100)}
                    showPagination={true}
                    SubComponent={this.createThreadComponent}
                />
            </div>
        );
    }
}
